export const MaxFilePathLength =  1018; // 1024 - 6 (since files can have satellite files with the ".props" extension)
export const WarningFilePathLength = 240;
